import React from 'react';
import { IntlProvider } from 'react-intl';
import { IntlContextProvider } from '../utils/context/intl-context';

// eslint-disable-next-line react/display-name
const withIntlProvider = (intl) => (children) =>
  (
    <IntlProvider
      defaultLocale={intl.defaultLanguage}
      locale={intl.language}
      messages={intl.messages}>
      <IntlContextProvider value={intl}>{children}</IntlContextProvider>
    </IntlProvider>
  );

export default ({ element, props }, themeOptions) => {
  if (!props || !themeOptions.wrapProvider) {
    return;
  }

  const { pageContext } = props;
  const { intl } = pageContext;

  return withIntlProvider(intl)(element);
};
